import { Field, Form, Formik } from 'formik';
import React from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentCardNoCol from '../../common/ParentCardNoCol';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';

export const CustomComponentForm = ({ projectId, version, history, addCustomComponentConfig }) => {
  const handleSubmit = (values) => {
    const { name } = values;
    addCustomComponentConfig({ projectId, name, version }).then((res) => {
      const { uuid } = res.data;
      history.replace(`/custom-component/${version}/v/${projectId}/customComponent/edit/${uuid}`);
    });
  };

  return (
    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
      <ParentCardNoCol
        title="Add Custom Component"
        icon="customComponent"
        bgColor="drapcode-violet"
      >
        <Formik
          initialValues={{ name: '' }}
          onSubmit={(values, { resetForm }) => {
            handleSubmit(values);
            resetForm();
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <CustomInputWithIcon icon="text" required={true}>
                      <Field
                        type="text"
                        name="name"
                        placeholder="Name"
                        className="form-control form-control-sm"
                      />
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-12 col-lg-12 mt-2 text-right">
                    <button
                      type="button"
                      className="btn btn-default btn-md"
                      onClick={() => {
                        resetForm();
                        history.goBack();
                      }}
                    >
                      <span>
                        <i className={`wb ${drapcodeIcon('cancel')}`}></i>&nbsp;Cancel
                      </span>
                    </button>
                    &nbsp;
                    <button type="submit" className="btn btn-theme-submit btn-md">
                      <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Save&nbsp;
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </ParentCardNoCol>
    </div>
  );
};
